class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.notificationWrapper = document.getElementById('cart-notification-wrapper');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    window.calculatePromotions();
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notificationWrapper.classList.add('open');
    document.body.style.overflow = 'hidden';
    
    // dont show final message in atb modal
    document.querySelectorAll('.cart-notification-product dl .product-option dt').forEach(function (dt) {
      const dd = dt.nextElementSibling;
      if (dt.textContent.trim() === 'Final Sale:' && dd) {
        dt.style.display = 'none';
        dd.style.display = 'none';
      }
    });

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.notificationWrapper.classList.remove('open');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.style.overflow = 'visible';

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (parsedState.items) {
      for (let i = 0; i < parsedState.items.length; i++) {
        this.cartItemKey = parsedState.items[i].key
      }
    } else {
      this.cartItemKey = parsedState.key;
    }
   
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    window.calculatePromotions();
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification || target === this.notificationWrapper && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
